import React from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Box from "../Box";
import Button from "../Button";
import Textfield from "../Merchant/Textfield";
import Toggle from "../Toggle";
interface Props {
  id: string;
  isEdit: boolean;
  onCancel: () => void;
  onSave: () => void;
  tariffData: {
    range: string;
    annual: string;
    monthly: string;
    daily: string;
    dropOrPickUp: string;
  };
  isActive: boolean;
  handleToggle: () => void;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error: {
    range: string;
    annual: string;
    monthly: string;
    daily: string;
    dropOrPickUp: string;
  }
}

const ManageTariff = ({
  id,
  isEdit = false,
  onCancel,
  onSave,
  tariffData,
  isActive,
  handleToggle,
  handleChange,
  error
}: Props) => {
  return (
    <LayoutContainer>
      <Box>
        <ManageTariffHeaderWrapper>
          <StyledText>{isEdit ? "Edit" : "Add"} Tariff</StyledText>
          <Toggle
            uniqueName="toggleTariff"
            isChecked={isActive}
            onChange={handleToggle}
          />
        </ManageTariffHeaderWrapper>
        <FormContainer>
          <Textfield
            name="range"
            required
            label="LOA-M"
            placeholder="Enter loa-m"
            value={tariffData.range}
            onChange={handleChange}
            helperText={error.range}
          />
          <Textfield
            name="annual"
            required
            label="Annual Berth Dues (QAR)"
            placeholder="Enter annual berth dues"
            value={tariffData.annual}
            onChange={handleChange}
            helperText={error.annual}
          />
          <Textfield
            name="monthly"
            required
            label="Monthly Berth Dues (QAR)"
            placeholder="Enter monthly berth dues"
            value={tariffData.monthly}
            onChange={handleChange}
            helperText={error.monthly}
          />
          <Textfield
            name="daily"
            required
            label="Daily Berth Dues (QAR)"
            placeholder="Enter daily berth dues"
            value={tariffData.daily}
            onChange={handleChange}
            helperText={error.daily}
          />
          <Textfield
            name="dropOrPickUp"
            required
            label="Drop Off/Pick Up (QAR)"
            placeholder="Enter drop off/pick up amount"
            value={tariffData.dropOrPickUp}
            onChange={handleChange}
            helperText={error.dropOrPickUp}
          />
          <div />
          <div />
          <ActionContainer>
            <Button width="150px" onClick={onCancel} label="Cancel" />
            <Button
              width="150px"
              variant="filled"
              color={Colors.red}
              onClick={onSave}
              label="Save"
            />
          </ActionContainer>
        </FormContainer>
      </Box>
    </LayoutContainer>
  );
};

const ManageTariffHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;
`;

const LayoutContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 2rem;
`;

const StyledText = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row;
  font-family: "Poppins-Medium";
  color: ${Colors.black};
  font-weight: 500;
  font-size: 1.25rem;
  font-style: normal;
  @media only screen and (max-width: 768px) {
    padding: 0;
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }
`;

const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ActionContainer = styled.div`
  justify-content: end;
  display: flex;
  gap: 1rem;
`;

export default ManageTariff;
